
import ListGenericSkills from "../app/modules/Performance/ResponsableRH/ListGenericSkills";
import CampagnePerformanceManagement from "../app/modules/Performance/CampagnePerformanceManagement";
import PerformanceCampaignList from "../app/modules/Performance/Collaborateur/PerformanceCampaignList";
import PerformanceEvaluationPage from "../app/modules/Performance/Collaborateur/PerformanceEvaluationPage";
import PerformanceManagerCampaignList from "../app/modules/Performance/Manager/PerformanceManagerCampaignList";
import PerformanceManagerCollaborateurs from "../app/modules/Performance/Manager/PerformanceManagerCollaborateurs";
import PerformanceManagerEvaluationPage from "../app/modules/Performance/Manager/PerformanceManagerEvaluationPage";
import DemandesModificationManagerPage from "../app/modules/Performance/Manager/DemandesModificationManagerPage";
import PerformanceConsolidationList from "../app/modules/Performance/ResponsableRH/PerformanceConsolidationList";
import PerformanceConsolidationDashboard from "../app/modules/Performance/ResponsableRH/PerformanceConsolidationDashboard";
import TDB from "../app/modules/Performance/TDB";
import TDBcollab from "../app/modules/Performance/Collaborateur/TDBcollab";
import TDBrespo from "../app/modules/Performance/ResponsableRH/TDBrespo";
import TDBmanager from "../app/modules/Performance/Manager/TDBmanager";


export const performanceRoutes = [

    { path: "/competences-generiques", element: <ListGenericSkills /> },
    { path: "/campagnes/performance", element: <CampagnePerformanceManagement /> },
    { path: "/performance", element: <PerformanceCampaignList /> },
    { path: "/performance/campagnes", element: <PerformanceCampaignList /> },
    { path: "/performance/evaluation/:progressId", element: <PerformanceEvaluationPage /> },
    { path: "/performance/manager", element: <PerformanceManagerCampaignList /> },
    { path: "/performance/manager/campagnes", element: <PerformanceManagerCampaignList /> },
    { path: "/performance/manager/campagnes/:campagneId/collaborateurs", element: <PerformanceManagerCollaborateurs /> },
    { path: "/performance/manager/evaluation/:progressId", element: <PerformanceManagerEvaluationPage /> },
    { path: "/performance/manager/demandes-modification", element: <DemandesModificationManagerPage /> },
    { path: "/performance/manager/campagnes/:campagneId", element: <PerformanceManagerCollaborateurs /> },
    { path: "/performance/manager/progress/:progressId", element: <PerformanceManagerEvaluationPage /> },
    { path: "/performance/manager/evaluation", element: <PerformanceManagerEvaluationPage /> },
    { path: "/performance/rh/consolidation", element: <PerformanceConsolidationList /> },
    { path: "/performance/rh/consolidation/:campagneId", element: <PerformanceConsolidationDashboard /> },
    { path: "/perf/dashboard", element: <TDB /> },
    { path: "/perf/dashboard/collab", element: <TDBcollab /> },
    { path: "/perf/dashboard/respo", element: <TDBrespo /> },
    { path: "/perf/dashboard/manager", element: <TDBmanager /> },
];
